import {
  Component, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef, Renderer2, Inject, HostBinding, OnInit
} from "@angular/core";
import {Observable, AsyncSubject} from "rxjs";
import {DOCUMENT} from "@angular/platform-browser";
import {ActivatedRoute, Router} from "@angular/router";
import {CostGuideUtils} from "../../../../common/utils/costguideutils";
import {TransferState} from "../../../modules/transfer-state/transfer-state";
import {LoopBackConfig} from "../../shared/sdk/lb.config";
import {BASE_URL, API_VERSION} from "../../shared/base.url";
import {routeAnimation} from "../../shared/animations/route.animation";
import {StringUtils} from "../../../../common/utils/stringutils";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";

@Component({
  templateUrl: 'cost-guide-list.component.html',
  styleUrls: [ 'cost-guide-list.component.scss' ],
  selector: 'costGuideListComponent',
  encapsulation: ViewEncapsulation.None,
/*  animations: [ routeAnimation ],
  host: {
    '[@routeAnimation]': 'true',
    '[style.display]': "'block'",
    '[style.position]': "'absolute'",
    '[style.left]' : "'0'",
    '[style.right]' : "'0'"
  }, */
})

export class CostGuideListComponent implements OnInit {

  public costGuidesView: Observable<any>;
  public categories = {};
  public costGuides = {};
  protected categoryIds = {};
  public searchForm: FormGroup;

  constructor(protected renderer: Renderer2,
              @Inject(DOCUMENT) protected  document: any,
              protected router: Router,
              protected route: ActivatedRoute,
              protected costGuideUtils: CostGuideUtils,
              @Inject(FormBuilder) protected formBuilder: FormBuilder,
              protected cache: TransferState) {

    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);

    let costGuideTitlesKey = 'cost-guide-titles';
    let costGuideList = this.cache.get(costGuideTitlesKey);
    if (costGuideList != null) {
      this.renderCostGuideList(costGuideList);
    }
    else {
      this.costGuideUtils.loadCostGuidesTitlesByGroupAndCategory().subscribe(costGuideList => {
        this.cache.set(costGuideTitlesKey, costGuideList);
        this.renderCostGuideList(costGuideList);
      });
    }
  }

  ngOnInit() {
    this.searchForm = this.formBuilder.group({
      search: new FormControl()
    });

    this.searchForm.valueChanges.subscribe(data => {
      let value = data.search;
      this.search(value);
    });

  }

  public search(value) {
    if(value == "") {
      $('.category-container').show();
      $('.links-container').hide();
      $('.cost-guide-link').show();
      let anchor = $('.cost-guide-link').each(function(index) {
        let anchor = $(this).find('a').html();
        anchor = anchor.replace(/(<b>|<\/b>)/igm, '');
        $(this).find('a').html(anchor);
      });
    }
    else {
      $('.category-container').each(function(index) {
        let categoryContainer = $(this);
        categoryContainer.hide(); //by default
        categoryContainer.find('.links-container').each(function (index) {
          let linksContainer = $(this);
          $(this).find(".cost-guide-link").hide();
          $(this).find(".cost-guide-link").each(function (index) {
            if ($(this).find('a').text().toLowerCase().indexOf(value.toLowerCase()) >= 0) {
              categoryContainer.show();
              linksContainer.show();
              $(this).show();
              let anchor = $(this).find('a').html();
              anchor = anchor.replace(/(<b>|<\/b>)/igm, '');
              var query = new RegExp("(" + value + ")", "gim");
              var newAnchor = anchor.replace(query, "<b>$1</b>");
              $(this).find('a').html(newAnchor);
            }
          });
        });
      });
    }
  }

  public openOrCloseCategory(category) {
    let categoryId = this.categoryIds[category];
    if($('.' + categoryId).css("display") == "none") {
      $('.' + categoryId).show();
      $('.' + categoryId + '-icon').removeClass('fa-angle-down');
      $('.' + categoryId + '-icon').addClass('fa-angle-up');
    }
    else {
      $('.' + categoryId).hide();
      $('.' + categoryId + '-icon').removeClass('fa-angle-up');
      $('.' + categoryId + '-icon').addClass('fa-angle-down');
    }
  }

  protected renderCostGuideList(costGuideList) {

    this.categories = {1: [], 2: [], 3: [], 4: []};
    this.costGuides = {1: [], 2: [], 3: [], 4: []};
    for(var groupId = 1; groupId <= 4; groupId++) {
      for (var categoryName in costGuideList[groupId]) {
        this.categories[groupId].push(categoryName);
        this.categoryIds[categoryName] = StringUtils.nameToId(categoryName)
      }
      this.categories[groupId].sort();
      this.costGuides[groupId] = costGuideList[groupId];
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/cost-guide/cost-guide-list/cost-guide-list.component.ts